/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleALeftIcon16Light = forwardRef('ArrowShapeTriangleALeftIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 3.922a1 1 0 0 0-1.546-.839l-6.193 4.03a1 1 0 0 0-.008 1.672l6.193 4.115A1 1 0 0 0 12 12.067V3.922Zm-7.194 4.03L11 3.922v8.145L4.806 7.952Z" })));
});
